module.exports = __webpack_public_path__ + "static/media/instagram.1d85f4c7.svg";